// blog post slider 
var swiper = new Swiper('.blog-post-slider', {
  navigation: {
    nextEl: '.post-slider-nav-next',
    prevEl: '.post-slider-nav-prev',
  },
  slidesPerView: 1,
  spaceBetween: 16,
  breakpoints: {
    1441: {
      slidesPerView: 4,
      spaceBetween: 42
    },
    1201: {
      slidesPerView: 4,
      spaceBetween: 30
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    481: {
      slidesPerView: 2,
      spaceBetween: 20
    },
  }
});



// mobile header
  $(document).ready(function () {
    $('.menu-drawer__menu-item--mainlist').on('click', function (e) {
      var $this = $(this);
      var $submenu = $this.next('.menu-drawer__menu--childlist');

      if ($this.is('a') && $submenu.length === 0) {
        return;
      }

      e.preventDefault();

      $('.menu-drawer__menu--childlist').not($submenu).slideUp();
      $('.menu-drawer__menu-item--mainlist').not($this).removeClass('is-open');

      $this.toggleClass('is-open');
      $submenu.slideToggle();
    });
  });

